import { useCallback, useEffect } from 'react';
export default function useSelectedDialogKeyBindings(opts) {
  const {
    onNextItem,
    onPreviousItem,
    onToggleEditor
  } = opts || {};
  const keydownListener = useCallback(evt => {
    switch (evt.code) {
      case 'ArrowLeft':
        onPreviousItem?.(evt);
        break;
      case 'ArrowRight':
        onNextItem?.(evt);
        break;
      case 'KeyI':
        onToggleEditor?.();
        break;
      default:
    }
  }, [onNextItem, onPreviousItem, onToggleEditor]);
  useEffect(() => {
    window.addEventListener('keydown', keydownListener);
    return () => {
      window.removeEventListener('keydown', keydownListener);
    };
  }, [keydownListener]);
}